const s = {
  name: "Ratio16x9",
  dimensions: { width: 40, height: 22 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 22" style="enable-background:new 0 0 40 22;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M36,4h-6v2h4v4h2V4z"/>
		<path class="st0" d="M6,12v4h4v2H4v-6H6z"/>
		<path class="st0" d="M40,0H0v22h40V0z M38,2v18H2V2H38z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Ratio16x9
};
